import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
import { renderless, api } from "@opentiny/vue-renderless/popover/vue";
import "@opentiny/vue-theme/popover/index.css";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  emits: ["update:modelValue", "hide", "show", "after-enter", "after-leave", "created"],
  props: [].concat(props, ["appendToBody", "arrowOffset", "boundariesPadding", "closeDelay", "content", "disabled", "modelValue", "offset", "openDelay", "placement", "popper", "popperClass", "popperOptions", "reference", "tabindex", "title", "transformOrigin", "transition", "trigger", "visibleArrow", "width", "height"]),
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("span", {
    ref: "root"
  }, [_c("transition", {
    attrs: {
      "name": _vm.transition
    },
    on: {
      "after-enter": _vm.handleAfterEnter,
      "after-leave": _vm.handleAfterLeave
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.disabled && _vm.state.showPopper,
      expression: "!disabled && state.showPopper"
    }],
    ref: "popper",
    staticClass: "tiny-popover tiny-popper",
    class: [_vm.popperClass, _vm.content && "tiny-popover__plain", {
      "no-arrow": !_vm.visibleArrow
    }],
    style: {
      width: _vm.width === "auto" ? _vm.width : _vm.width + "px",
      height: _vm.height === "auto" ? _vm.height : _vm.height + "px"
    },
    attrs: {
      "role": "tooltip",
      "id": _vm.state.tooltipId,
      "aria-hidden": _vm.disabled || !_vm.state.showPopper ? "true" : "false"
    }
  }, [_vm.title ? _c("div", {
    staticClass: "tiny-popover__title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.content))];
  })], 2)]), _c("span", {
    ref: "wrapper",
    staticClass: "reference-wrapper",
    class: {
      "reference-wrapper-show": !_vm.disabled && _vm.state.showPopper
    }
  }, [_vm._t("reference")], 2)], 1);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var pc = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  pc as default
};
